const utils = {
  randomSort: (min: number = -1, max: number = 1) =>
    Math.floor(Math.random() * (max - min + 1) + min),
};

export default utils;
